const abi = require("./abi.json");
module.exports = {
  56: {
    address: "0xA0A2eE912CAF7921eaAbC866c6ef6FEc8f7E90A4",
    abi,
  },
};
